import { useEffect, useState } from 'react';
import { fetchData } from './Helpers';

import { freeWImg, privateImg, professionalImg, dividendsImg, fundamentalsImg, regionImg, resolveImage } from "../../images/ImageResolver";

function EventsDropdown({ type, wealthFullData }) {
  return(
    <div>
      {wealthFullData.map((row, index) => (
      <ef-layout className="wealth-detail-layout" key={index}>
        <ef-layout>
          <p>{row ? row.indicators : ""}</p>
          <ef-layout flex className="event-wealth-detail-banner wealth-detail-banner">
            <ef-layout>
              {type === "free" && <h5>{row ? row.public : ""}</h5>}
              {type === "private" && <h5>{row ? row.private : ""}</h5>}
              {type === "professional" && <h5>{row ? row.professional : ""}</h5>}
            </ef-layout>
            <ef-layout>
              <img src={regionImg} alt="Region" />
            </ef-layout>
          </ef-layout>
        </ef-layout>
        <ef-layout className="comment-layout">
          <span>Licenses</span>
          {type === "free" && <p className='commentP'>{row ? row.publicLicenses : ""}</p>}
          {type === "private" && <p className='commentP'>{row ? row.privateLicenses : ""}</p>}
          {type === "professional" && <p className='commentP'>{row ? row.professionalLicenses : ""}</p>}
        </ef-layout>
      </ef-layout>
      ))}
    </div>
  )
}

function InfoDropdown({ type, infoData }) {

  return(
    <div>
      <ef-layout className="comment-layout">
        <table>
          <thead>
            <tr>
              <th>History</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {infoData.filter(row => row["segementation"].trim() === "History").map((row, index) => (
              <tr key={index}>
                <td>{row["eventTypes"]}</td>
                { type === "free" && <td>{row["public"]}</td> }
                { type === "private" && <td>{row["private"]}</td> }
                { type === "professional" && <td>{row["professional"]}</td> }
              </tr>
            ))}
          </tbody>
        </table>
      </ef-layout>
      <ef-layout className="comment-layout">
        <table>
            <thead>
              <tr>
                <th>Forward Looking</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {infoData.filter(row => row["segementation"].trim() === "Forward Looking").map((row, index) => (
                <tr key={index}>
                  <td>{row["eventTypes"]}</td>
                  { type === "free" && <td>{row["public"]}</td> }
                  { type === "private" && <td>{row["private"]}</td> }
                  { type === "professional" && <td>{row["professional"]}</td> }
                </tr>
              ))}
            </tbody>
          </table>
      </ef-layout>
      <ef-layout>
        <p className='commentP'>*Confirmed dates only</p>
        <p className='commentP'>**Clients are required to purge the IPO and M&A content so that they never store data beyond the 3 month (IPO) and 2 year (M&A) historical limits.  Clients that redistribute this data are liable to ensure that their redistribution partners adhere to these terms as well.</p>
        <p className='commentP'>***Data available in endpoint but not approved for use for free-to-air applications</p>
      </ef-layout>
      <ef-layout className="events-wealth-bottom-bar">
        { type === "free" &&
        <p className='commentP'>
          <ef-icon icon="admin-profile"></ef-icon>
          {infoData.filter(row => row["segementation"].trim() === "Redistribution- Public Non Professional")[0]["eventTypes"]}
        </p>
        }
        { type === "private" &&
        <p className='commentP'>
          <ef-icon icon="admin-profile"></ef-icon>
          {infoData.filter(row => row["segementation"].trim() === "Redistribution - Private Non-Professional")[0]["eventTypes"]}
        </p>
        }
        { type === "professional" &&
        <p className='commentP'>
          <ef-icon icon="admin-profile"></ef-icon>
          {infoData.filter(row => row["segementation"].trim() === "Professional - Internal Only")[0]["eventTypes"]}
        </p>
        }
      </ef-layout>
    </div>
  )
}

function Package({type, wealthData, infoData}) {

  const [info,setInfo] = useState(false);
  const [showEvents,setShowEvents] = useState(false);
  const [showPremiumEvents,setShowPremiumEvents] = useState(false);

  return(
    <div className='public-div'>
      <ef-tab-bar level="3">
        <ef-tab label="PLI" value="tab1" active onClick={() => setInfo(false)}></ef-tab>
        <ef-tab label="Information" value="tab2" onClick={() => setInfo(true)}></ef-tab>
      </ef-tab-bar>
      <ef-layout className="package-layout">
        {!info &&
        <ef-layout>
          <ef-layout className="inner-layout" onClick={() => setShowEvents(!showEvents)}>
            <ef-panel spacing>
              <img src={dividendsImg} alt="Dividends" />
              <span>Events</span>
              {!showEvents && <ef-icon icon="down"></ef-icon>}
              {showEvents && <ef-icon icon="up"></ef-icon>}
            </ef-panel>
          </ef-layout>
          {showEvents && <EventsDropdown type={type} wealthFullData={wealthData.filter(row => row["packages"].trim() === "Events")} />}
          <ef-layout className="inner-layout" onClick={() => setShowPremiumEvents(!showPremiumEvents)}>
            <ef-panel spacing>
              <img src={fundamentalsImg} alt="Fundamentals" />
              <span>Events Premium</span>
              {!showPremiumEvents && <ef-icon icon="down"></ef-icon>}
              {showPremiumEvents && <ef-icon icon="up"></ef-icon>}
            </ef-panel>
          </ef-layout>
          {showPremiumEvents && <EventsDropdown type={type} wealthFullData={wealthData.filter(row => row["packages"].trim() === "Events Premium")} />}
        </ef-layout>
        }
        { info && <InfoDropdown type={type} infoData={infoData} />}
      </ef-layout>
    </div>
  );
}

function WealthPackages() {
  const [packageLayout, setPackageLayout] = useState("free");
  const [wealthData, setWealthData] = useState([]);
  const [infoData, setInfoData] = useState([]);
  const [dataLoaded, setDataLoaded] = useState(false);

  useEffect(() => {
    fetchData("Event_Packages_Endpoints").then(res => {
      setWealthData(res);
      setDataLoaded(true);
    });
    fetchData("Event_Data_Display_Restrictions").then(res => {
      setInfoData(res);
      setDataLoaded(true);
    });
  }, []);

  useEffect(() => {
    const buttonBar = document.getElementById('wealthBar');
    buttonBar.addEventListener('click', (event) => {
      let buttonId = '';
      if(event.target.getAttribute('id')) {
        buttonId = event.target.getAttribute('id');
      }else {
        buttonId = event.target.parentElement.getAttribute('id');
      }
      const buttons = buttonBar.querySelectorAll('ef-button');
      buttons.forEach(btn => {
        btn.active = false;
        btn.children[0].src = resolveImage(btn.getAttribute('id'));
      });
      const btn = document.getElementById(buttonId);
      btn.active = true;
      btn.children[0].src = resolveImage(`${buttonId}-w`);
      setPackageLayout(buttonId);
    });
  }, []);

  return(
    <div className='wealth-packages'>
      <ef-loader class="loader" hidden={dataLoaded}></ef-loader>
      <h4>WEALTH PACKAGES</h4>
      <ef-layout flex>
        <ef-layout>
          <ef-button-bar id="wealthBar">
            <ef-button-bar managed>
              <ef-button id="free" toggles active><img src={freeWImg} alt="Public"/>Public</ef-button>
              <ef-button id="private" toggles><img src={privateImg} alt="Private"/>Private</ef-button>
              <ef-button id="professional" toggles><img src={professionalImg} alt="Professional"/>Professional</ef-button>
            </ef-button-bar>
          </ef-button-bar>
        </ef-layout>
      </ef-layout>
      {packageLayout === "free" && <Package type="free" wealthData={wealthData} infoData={infoData} />}
      {packageLayout === "private" && <Package type="private" wealthData={wealthData} infoData={infoData} />}
      {packageLayout === "professional" && <Package type="professional" wealthData={wealthData} infoData={infoData} />}
    </div>
  )
}

export default WealthPackages;